import { combineReducers } from "redux";
import data from "./data";
import stallsdata from "./stallsdata";


export default combineReducers({ data, stallsdata });
